<template>
    <div>
        <div class="text-sm font-medium text-gray-500 mb-1">{{ label }}</div>
        <div class="text-base text-gray-800 dark:text-white">{{ value || '—' }}</div>
    </div>
</template>

<script>
    export default {
        name: 'InfoField',
        props: {
            label: String,
            value: String,
        },
    };
</script>
